import Icon from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {getManagedPubACS} from 'store/managedPub/requestAC';
import PubBase from 'typescript/models/PubBase';

import PubLogoDefault from '../../assets/images/pub-logo-default.png';
import './PubSwitcherCard.scss';

interface IProps {
  active?: boolean;
  pub: PubBase;
}

export default function PubSwitcherCard({active = false, pub}: IProps) {
  const dispatch = useSetGlobalState();
  const {managedPub} = useGlobalState((state) => state.managedPub);

  const handleSwitchPub = () => {
    if (managedPub?.id === String(pub.id)) return;

    dispatch(getManagedPubACS(String(pub.id)));
  };

  return (
    <div
      className={`pub-switcher-card ${active ? 'pub-switcher-card--active' : ''}`}
      role="button"
      onClick={handleSwitchPub}
      data-testid="pub-switcher-card"
    >
      <div className="pub-switcher-card__name">
        <div className="pub-switcher-card__logo">
          {pub.pub_logo ? (
            <img src={pub.pub_logo} alt="pub logo" />
          ) : (
            <img src={PubLogoDefault} data-testid="pub-switcher-placeholder" alt="pub logo" />
          )}
        </div>
        <div className="pub-switcher-card__text">
          <Text tag="h4" uppercase data-testid="pub-switcher-card-name">
            {pub.name || '/'}
          </Text>
          <Text tag="span" data-testid="pub-switcher-card-email">
            {pub.email || '/'}
          </Text>
        </div>
      </div>
      <div className="pub-switcher-card__switch">
        <Icon icon="check" />
      </div>
    </div>
  );
}
